export enum UserTypes {
  ADMIN = 1,
  CHEF = 2,
  DRIVER = 3,
  CASHIER = 4,
  MANAGER = 5,
  PREPARATOR = 6,
  WAITER = 7
}
